import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation, ElementRef, Input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
// Removed Angular Material sort imports
// Removed Angular Material dialog/table; using custom OWC modal instead
import { Router } from '@angular/router';
import { NotificationSearchService } from '../notification-search/notification-search.service';

import { accountTableColumns, accountTableInit } from '../../constants';
import { NotificationAddRecipientsTemplateDialogComponent } from '../notification-add-recipients-template-dialog/notification-add-recipients-template-dialog.component';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
// Removed OneSnackBar import; using SnackbarService
// import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { NotificationAuditTrailComponent } from '../notification-audit-trail/notification-audit-trail.component';
import { FileFormatDialogComponent } from '../file-format-dialog/file-format-dialog.component';
import { OneWebComponentsAngularModule } from '@one/angular';
import { AppUtils } from '../../utlis/app-utils';
import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SnackbarService } from '../../services/snackbar.service';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';

@Component({
  selector: 'dl-notification-accounts-table',
  standalone: true,
  imports: [OneWebComponentsAngularModule, NotificationAddRecipientsTemplateDialogComponent, FileFormatDialogComponent, CommonModule, NotificationAuditTrailComponent, FormsModule],
  templateUrl: './notification-accounts-table.component.html',
  styleUrl: './notification-accounts-table.component.scss'
})
export class NotificationAccountsTableComponent {
  //  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild('exporter', { static: true }) exporter: ElementRef;
  @Input() notificationDetails: any;
  @Input() selectedRecepientColumns: any;
  @Input() contactDetails: any;
  @Input() notificationLabel: any;
  @Input() contactDataDetails: any;
  @Input() isSetCom: boolean = false;
  @Input() isSetCancelled: boolean = false;
  public visibleDownload: boolean = false;
  public visibleAddRecipients: boolean = false;
  public data: any;

  public displayedColumns: Array<string> = []
  public dataSource: any[] = [];
  selectedRows: Set<any> = new Set();
  inputData: { tableData: any; };
  visibleAuditTrail: boolean;
  ;
  public selection: any[] = [];
  public selectedRow: any;
  public userPermission: any;
  public isAddRecipientDisabled = false;
  public isAfoBtnDisabled = false;
  public isAfoBtnExpanded = false;
  public filteredStatusList: any;
  public auditTrailDatafromAPI: any;
  public notificationId: any;
  public visibleResendConfirm: boolean = false;
  
  // Sorting properties
  sortInfo: { column: string, direction: string }[] = [];
  originalContactDetails: any[] = []; // Store original data for sorting

  public constructor(
    public router: Router,
    public appUtils: AppUtils,
    public qnsbnService: QnSbnService,
    public filterOverlay: FilterOverlayDialogService,
    public notificationSearchService: NotificationSearchService,
    public changeDetectorRef: ChangeDetectorRef,
    private snackBarNotification: SnackbarService,
    private _QnSbnDataService: QnSbnDataServiceService,

  ) { }

  public ngOnInit(): void {
    this.userPermission = this.qnsbnService.getUserData();

    if (this.selectedRecepientColumns > 0) {
      const recipientColumns = ['select'];
      let selectedColumns = this.selectedRecepientColumns.map(columnValue => columnValue.value);


      accountTableColumns.forEach(colObj => {
        if (selectedColumns.indexOf(colObj.value) !== -1) {
          recipientColumns.push(colObj.value);
        }
      });

      recipientColumns.push('Arrow');
      this.displayedColumns = recipientColumns;
    }

    // Store original data for sorting
    this.originalContactDetails = Array.isArray(this.contactDetails) ? [...this.contactDetails] : [];
    this.dataSource = this.applySorting(this.originalContactDetails);

    if (Array.isArray(this.contactDetails) && this.contactDetails.length > 0) {
      this.filteredStatusList = this.contactDetails
        .map(item => item?.AccountStatus)
        .filter((value, index, self) => value && self.indexOf(value) === index);
      if (this.filterOverlay && typeof this.filterOverlay.setStatusName === 'function') {
        this.filterOverlay.setStatusName(this.filteredStatusList);
      }
    }

    this.notificationSearchService.searchData$.subscribe(searchValue => {
      if (!searchValue || typeof searchValue !== 'string') {
        this.dataSource = this.applySorting(Array.isArray(this.originalContactDetails) ? this.originalContactDetails : []);
        return;
      }

      const filter = searchValue.toLowerCase();
      const filteredData = Array.isArray(this.originalContactDetails) ? 
        this.originalContactDetails.filter((data: any) => {
          if (!data) return false;

          return this.appUtils.getLowerCase(data.AccountId).includes(filter)
            || this.appUtils.getLowerCase(data.AccountName).includes(filter)
            || this.appUtils.getLowerCase(data.AccountDateSent).includes(filter)
            || this.appUtils.getLowerCase(data.AccountDateDelivered).includes(filter)
            || this.appUtils.getLowerCase(data.AccountDateRead).includes(filter)
            || this.appUtils.getLowerCase(data.AccountFeedbackReceived).includes(filter)
            || this.appUtils.getLowerCase(data.AccountStatus).includes(filter)
            || this.appUtils.getLowerCase(data.DeliveryFailures).includes(filter);
        }) : [];
      
      this.dataSource = this.applySorting(filteredData);
      
      // Use setTimeout to prevent change detection loops
      setTimeout(() => {
        if (this.changeDetectorRef && !this.changeDetectorRef['destroyed']) {
          try {
            this.changeDetectorRef.detectChanges();
          } catch (error) {
            console.warn('Change detection error in search subscription:', error);
          }
        }
      }, 0);
    });

    this.filterOverlay.filterData$.subscribe(filterValue => {
      this.filterSourceTable(filterValue);
    });

    this.isAddRecipientDisabled = this.notificationDetails.notificationData.Status === 'Complete' || this.notificationDetails.notificationData.Status === 'Completed' || this.notificationDetails.notificationData.Status === 'Cancelled';
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // Prevent infinite recursion by checking if changes are meaningful
    if (!changes || Object.keys(changes).length === 0) {
      return;
    }

    // Only update user permission if necessary
    if (this.qnsbnService && typeof this.qnsbnService.getUserData === 'function') {
      this.userPermission = this.qnsbnService.getUserData();
    }

    // Only rebuild columns if selectedRecepientColumns actually changed
    if (changes['selectedRecepientColumns'] && this.selectedRecepientColumns && Array.isArray(this.selectedRecepientColumns)) {
      const recipientColumns = ['select'];
      let selectedColumns = this.selectedRecepientColumns.map(columnValue => columnValue?.value).filter(Boolean);

      if (Array.isArray(accountTableColumns)) {
        accountTableColumns.forEach(colObj => {
          if (colObj && selectedColumns.indexOf(colObj.value) !== -1) {
            recipientColumns.push(colObj.value);
          }
        });
      }

      recipientColumns.push('Arrow');
      this.displayedColumns = recipientColumns;
    }

    // Only update dataSource if contactDetails actually changed
    if (changes['contactDetails']) {
      this.dataSource = Array.isArray(this.contactDetails) ? [...this.contactDetails] : [];
    }

    // Only update disabled state if notificationDetails changed
    if (changes['notificationDetails'] && this.notificationDetails?.notificationData) {
      const status = this.notificationDetails.notificationData.Status;
      this.isAddRecipientDisabled = status === 'Complete' || status === 'Completed'|| status === 'Cancelled';
      
      if (this.isAddRecipientDisabled) {
        this.isSetCom = true;
        this.isSetCancelled = true;
      }
    }

    // Use setTimeout to prevent infinite recursion in change detection
    setTimeout(() => {
      if (this.changeDetectorRef && !this.changeDetectorRef['destroyed']) {
        try {
          this.changeDetectorRef.detectChanges();
        } catch (error) {
          console.warn('Change detection error in ngOnChanges:', error);
        }
      }
    }, 0);
  }

  isAllSelected(): boolean {
    if (!Array.isArray(this.dataSource) || !this.selectedRows) {
      return false;
    }
    const enabledRows = this.dataSource.filter(row => row && !row.disabled);
    return enabledRows.length > 0 && enabledRows.every(row => this.selectedRows.has(row));
  }


  isIndeterminate(): boolean {
    if (!Array.isArray(this.dataSource) || !this.selectedRows) {
      return false;
    }
    const enabledRows = this.dataSource.filter(row => row && !row.disabled);
    return this.selectedRows.size > 0 && !this.isAllSelected();
  }


  masterToggle(): void {
    if (!this.selectedRows) {
      this.selectedRows = new Set();
    }
    
    if (this.isAllSelected()) {
      this.selectedRows.clear();
    } else {
      if (Array.isArray(this.dataSource)) {
        this.selectedRows = new Set(this.dataSource.filter(row => row && !row.disabled));
      }
    }
  }


  toggleRow(row: any): void {
    if (!row || row.disabled || !this.selectedRows) return;

    if (this.selectedRows.has(row)) {
      this.selectedRows.delete(row);
    } else {
      this.selectedRows.add(row);
    }
  }

  public toggleSelection(row: any): void {
    if (this.isSelected(row)) {
      this.selectedRows.delete(row);
    } else {
      this.selectedRows.add(row);
    }
  }

  public isSelected(row: any): boolean {
    return this.selectedRows.has(row);
  }

  public ndAddRecepients(): void {
    this.isAfoBtnDisabled = false;
    this.isAfoBtnExpanded = false;

    const tableColumnData = ['dragHandle', 'select', 'selectType', 'selectText', 'iconSets'];
    const templateDataList = [
      {
        dragHandle: '',
        select: '',
        selectType: 'Checkbox',
        selectText: 'Do you agree to it?',
        iconSets: 'delete-icon'
      },
      {
        dragHandle: '',
        select: '',
        selectType: 'Question',
        selectText: 'How are you?',
        iconSets: 'delete-icon'
      },
      {
        dragHandle: '',
        select: '',
        selectType: 'Checkbox',
        selectText: 'Are you ready?',
        iconSets: 'delete-icon'
      }
    ];

    this.data = {
      tableData: templateDataList,
      columnData: tableColumnData,
      notificationData: this.notificationDetails.notificationData,
      contactList: this.contactDataDetails
    };
    this.visibleAddRecipients = true;
  }

  public onAddRecipientsClosed(result: any) {
    this.visibleAddRecipients = false;

    if (!result || !result.data) {
      return;
    }

    this.isAfoBtnDisabled = false;
    this.isAfoBtnExpanded = false;
    this.contactDetails = Array.isArray(result.data) ? result.data : [];
    this.dataSource = Array.isArray(result.accData) ? result.accData : [];
    
    // Use setTimeout to prevent change detection loops
    setTimeout(() => {
      if (this.changeDetectorRef && !this.changeDetectorRef['destroyed']) {
        try {
          this.changeDetectorRef.detectChanges();
        } catch (error) {
          console.warn('Change detection error in onAddRecipientsClosed:', error);
        }
      }
    }, 0);
  }

  public viewAuditTrail(): void {
    this.notificationId = this.notificationDetails.notificationData.NotificationId;
    this.qnsbnService.getNotificationAuditTrailList(this.notificationId).subscribe(
      res => {
        this.auditTrailDatafromAPI = res;
        this.inputData = {
          tableData: this.auditTrailDatafromAPI
        };
        this.visibleAuditTrail = true;
        this.changeDetectorRef.detectChanges();
      },
      err => {
        this.snackBarNotification.snackBarMessage('alarm', 'Failed to fetch Audit Trail Data');
      }
    );
  }

  public gotoAccountDetailsPage(row) {
    let rowData = {
      customerData: row,
      isSetCom: this.isSetCom,
      isSetCancelled: this.isSetCancelled,
      notificationStatus: this.isAddRecipientDisabled,
      notificationData: this.notificationDetails.notificationData
    };
    this.qnsbnService.getContactList(row.AccountNotificationId).subscribe({
      next: (res) => {
        this.router.navigateByUrl('/account-details', {
          state: {
            customerDetails: rowData,
            notificationDataObj: res.body
          }
        });
      },
      error: (err) => {
        this.snackBarNotification.snackBarMessage('alarm', 'Failed to fetch Contact Data');
      }
    });

  }

  public filterSourceTable(filterValue: any) {
    if (!filterValue || !Array.isArray(this.originalContactDetails)) {
      return;
    }

    let datesent_start = this.appUtils.formatDateOnly(filterValue.dateSent_sdate);
    let datesent_end = this.appUtils.formatDateOnly(filterValue.dateSent_edate);
    let delivered_sdate = this.appUtils.formatDateOnly(filterValue.dateDelivered_sdate);
    let delivered_edate = this.appUtils.formatDateOnly(filterValue.dateDelivered_edate);
    let dateRead_sdate = this.appUtils.formatDateOnly(filterValue.dateRead_sdate);
    let dateRead_edate = this.appUtils.formatDateOnly(filterValue.dateRead_edate);
    let feedbackReceived_sdate = this.appUtils.formatDateOnly(filterValue.feedbackReceived_sdate);
    let feedbackReceived_edate = this.appUtils.formatDateOnly(filterValue.feedbackReceived_edate);

    if (
      (!filterValue.statusFilters || filterValue.statusFilters.length < 1)
      && filterValue.dateSent_sdate == ''
      && filterValue.dateDelivered_sdate == ''
      && filterValue.dateRead_sdate
      && filterValue.feedbackReceived_sdate
    ) {
      this.dataSource = Array.isArray(this.contactDetails) ? [...this.contactDetails] : [];
    } else {
      const statusFilterArray = this.originalContactDetails.filter(data => 
        !data || !filterValue.statusFilters || filterValue.statusFilters.includes(data.AccountStatus) || filterValue.statusFilters == '');
      const datedeliveredFilterArray = statusFilterArray.filter(data => 
        !data || (this.appUtils.formatDateOnly(data.AccountDateDelivered) >= delivered_sdate && this.appUtils.formatDateOnly(data.AccountDateDelivered) <= delivered_edate) || filterValue.dateDelivered_sdate == '');
      const datesentFilterArray = datedeliveredFilterArray.filter(data => 
        !data || (this.appUtils.formatDateOnly(data.AccountDateSent) >= datesent_start && this.appUtils.formatDateOnly(data.AccountDateSent) <= datesent_end) || filterValue.dateSent_edate == '');
      const datereadFilterArray = datesentFilterArray.filter(data => 
        !data || (this.appUtils.formatDateOnly(data.AccountDateRead) >= dateRead_sdate && this.appUtils.formatDateOnly(data.AccountDateRead) <= dateRead_edate) || filterValue.dateRead_sdate == '');
      const feedbackReceivedFilterArray = datereadFilterArray.filter(data => 
        !data || (this.appUtils.formatDateOnly(data.AccountFeedbackReceived) >= feedbackReceived_sdate && this.appUtils.formatDateOnly(data.AccountFeedbackReceived) <= feedbackReceived_edate) || filterValue.feedbackReceived_sdate == '');
      const filteredResults = feedbackReceivedFilterArray.filter(
        data => !data || this.appUtils.getLowerCase(data.AccountDateRead)
          || this.appUtils.getLowerCase(data.AccountFeedbackReceived)
          || this.appUtils.getLowerCase(data.AccountStatus)
          || this.appUtils.getLowerCase(data.AccountDateDelivered)
          || this.appUtils.getLowerCase(data.AccountDateSent)
      );
      this.dataSource = this.applySorting(filteredResults);
    }
    
    // Use setTimeout to prevent change detection loops
    setTimeout(() => {
      if (this.changeDetectorRef && !this.changeDetectorRef['destroyed']) {
        try {
          this.changeDetectorRef.detectChanges();
        } catch (error) {
          console.warn('Change detection error in filterSourceTable:', error);
        }
      }
    }, 0);
  }

  public displayStatus(status) {
    const statusText = status ? status : 'Pending';
    return statusText;
  }

  public downloadReport(): void {
    this.visibleDownload = true;
  }

  public onFileFormatSelected(format: string): void {
    this.visibleDownload = false;

    if (format === 'csv') {
      this.downloadCSV();
    } else if (format === 'xlsx') {
      this.downloadXlsx();
    }
  }

  public downloadCSV() {

    let csvData: any = {};
    let AccountNotificationId: any[] = [];
    let notificationId: any = this.dataSource[0].NotificationId;
   

    this.selectedRows.forEach(i => AccountNotificationId.push(i.AccountNotificationId));

    const fetchCsvApi = {
      NotificationId: notificationId,
      AccountNotificationIds: AccountNotificationId
    }

    const fetchCsvJson = JSON.stringify(fetchCsvApi);

    this.qnsbnService.fetchCSV(fetchCsvJson).subscribe(
      (data: any) => {

        csvData = data;

        // Enrich Account rows with feedback form metadata (Label, Type, Mandatory)
        // so the CSV matches the Excel output
        const feedbackForms = Array.isArray(csvData.FeedbackForms) ? csvData.FeedbackForms[0] : {};
        const enrichedAccounts = csvData.Accounts.map((row) => {
          const newRow = {};
          Object.keys(row).forEach(key => {
            const feedbackValueMatch = key.match(/^Feedback(\d+)Value$/i);
            if (feedbackValueMatch) {
              const idx = feedbackValueMatch[1];
              if (feedbackForms[`Feedback${idx}Label`] !== undefined) {
                newRow[`Feedback${idx}Label`] = feedbackForms[`Feedback${idx}Label`];
              }
              if (feedbackForms[`Feedback${idx}Type`] !== undefined) {
                newRow[`Feedback${idx}Type`] = feedbackForms[`Feedback${idx}Type`];
              }
              if (feedbackForms[`Feedback${idx}Mandatory`] !== undefined) {
                newRow[`Feedback${idx}Mandatory`] = feedbackForms[`Feedback${idx}Mandatory`];
              }
            }
            const cellVal = row[key];
            if (cellVal && typeof cellVal === 'object' && !Array.isArray(cellVal) && cellVal.fileName) {
              newRow[key] = cellVal.fileName;
            } else if (Array.isArray(cellVal)) {
              newRow[key] = cellVal.join(', ');
            } else {
              newRow[key] = cellVal;
            }
          });
          return newRow;
        });

        const headers = {
          ReconciliationStatsHeader: Object.keys(csvData.ReconciliationStats[0]),
          ReconciliationDataHeader: Object.keys(csvData.Contacts[0]),
          AccountSummaryHeader: Object.keys(enrichedAccounts[0]),
          FeedbackFormsHeader: Object.keys(csvData.FeedbackForms[0])
        }


        const values = {
          ReconciliationStatsValue: csvData.ReconciliationStats.map((item) => Object.values(item).toString()),
          ReconciliationDataValue: csvData.Contacts.map(
            (item) => {
              return Object.values(item).map(
                (val) => {
                  let strVal = val.toString();
                  if (strVal.includes(',')) {
                    return `"${strVal}"`
                  } else {
                    return strVal
                  }
                }
              )
            }
          ),
          AccountSummaryValue: enrichedAccounts.map(
            (item) => {
              return Object.values(item).map(
                (val: any) => {
                  let strVal;
                  if (val && typeof val === 'object' && !Array.isArray(val) && val.fileName) {
                    strVal = val.fileName;
                  } else if (Array.isArray(val)) {
                    strVal = val.join(', ');
                  } else {
                    strVal = val != null ? val.toString() : '';
                  }
                  if (strVal.includes(',')) {
                    return `"${strVal}"`
                  } else {
                    return strVal
                  }
                }
              )
            }
          ),
          FeedbackFormsValue: csvData.FeedbackForms.map(
            (item) => {
              return Object.values(item).map(
                (val) => {
                  let strVal = val.toString();
                  if (strVal.includes(',')) {
                    return `"${strVal}"`
                  } else {
                    return strVal
                  }
                }
              )
            }
          ),
        }

        this.appUtils.exportToCSV(values, this.notificationLabel, headers);

      },
      (error: HttpErrorResponse) => {
        this.qnsbnService.httpErrorHandler(error, 'Please try again later.');
      }
    );
  }

  public downloadXlsx() {

    let AccountNotificationId: any[] = [];
    let notificationId: any = this.dataSource[0].NotificationId;

    this.selectedRows.forEach(i => AccountNotificationId.push(i.AccountNotificationId));

    const fetchCsvApi = {
      NotificationId: notificationId,
      AccountNotificationIds: AccountNotificationId
    }

    const fetchCsvJson = JSON.stringify(fetchCsvApi);

    this.qnsbnService.fetchCSV(fetchCsvJson).subscribe(
      (data: any) => {
        const reportData = {
          AccountSummary: data.Accounts,
          ReconciliationStats: data.ReconciliationStats,
          ReconciliationData: data.Contacts,
          FeedbackForms: data.FeedbackForms
        }
        this.appUtils.downloadExcel(reportData, this.notificationLabel);
      },
      (error: HttpErrorResponse) => {
        this.qnsbnService.httpErrorHandler(error, 'Please try again later.');
      }
    );
  }

  public OnSort(column: string, value: string): void {
    const existingSortIndex = this.sortInfo.findIndex(sort => sort.column === column);
    if (existingSortIndex !== -1) {
      this.sortInfo.splice(existingSortIndex, 1);
    }
    if (value !== 'default') {
      this.sortInfo.push({ column, direction: value });
    }
    
    if (Array.isArray(this.dataSource)) {
      this.dataSource = this.applySorting(this.dataSource);
    }
    
    // Use setTimeout to prevent change detection loops
    setTimeout(() => {
      if (this.changeDetectorRef && !this.changeDetectorRef['destroyed']) {
        try {
          this.changeDetectorRef.detectChanges();
        } catch (error) {
          console.warn('Change detection error in sorting:', error);
        }
      }
    }, 0);
  }

  applySorting(data: any[]): any[] {
    if (!Array.isArray(data)) {
      return [];
    }
    
    const dataCopy = [...data];
    if (Array.isArray(this.sortInfo) && this.sortInfo.length > 0) {
      return dataCopy.sort((a, b) => {
        for (let i = this.sortInfo.length - 1; i >= 0; i--) {
          const { column, direction } = this.sortInfo[i];
          const aValue = a?.[column] ?? '';
          const bValue = b?.[column] ?? '';
          if (aValue < bValue) return direction === 'asc' ? -1 : 1;
          if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return dataCopy;
  }

   public resendNotification(): void {
    this.visibleResendConfirm = true;
    
    // Use setTimeout to prevent change detection loops
    setTimeout(() => {
      if (this.changeDetectorRef && !this.changeDetectorRef['destroyed']) {
        try {
          this.changeDetectorRef.detectChanges();
        } catch (error) {
          console.warn('Change detection error in resendNotification:', error);
        }
      }
    }, 0);
  }

  public cancelBulkResend(): void {
    this.visibleResendConfirm = false;
  }

  public confirmBulkResend(): void {
    const notificationId = this.notificationDetails?.notificationData?.NotificationId;
    if (!notificationId) {
      this.snackBarNotification.snackBarMessage('alarm', 'Invalid notification.');
      this.visibleResendConfirm = false;
      return;
    }

    const payload = JSON.stringify({ notificationId: notificationId });
    this.qnsbnService.postBulkResendNotifications(payload).subscribe({
      next: () => {
        this.visibleResendConfirm = false;
        this.snackBarNotification.snackBarMessage('positive', 'Resend initiated for non-responsive recipients.');
        
        // Use setTimeout to prevent change detection loops
        setTimeout(() => {
          if (this.changeDetectorRef && !this.changeDetectorRef['destroyed']) {
            try {
              this.changeDetectorRef.detectChanges();
            } catch (error) {
              console.warn('Change detection error in bulk resend success:', error);
            }
          }
        }, 0);
      },
      error: (error: HttpErrorResponse) => {
        this.visibleResendConfirm = false;
        this.qnsbnService.httpErrorHandler(error, 'Failed to resend notification.');
      }
    });
  }

    public openNotificationDetails(row) {
    sessionStorage.setItem('reloadOverview','true');
    
       if(this.userPermission.CreateNotification || this.userPermission.SendNotification) {

      this.qnsbnService.createNotificationVersion(row.NotificationId).subscribe(
        (response: any) => {
          let versionData = response.body || response;
          if (typeof versionData === 'string') {
            versionData = JSON.parse(versionData);
          }
           
          this._QnSbnDataService.resetAll();

          this.qnsbnService.getNotificationContactDetails(row.NotificationId).subscribe(
            (newdata:any) => {
              if(newdata.length > 0) {
                const recipientData = []
                newdata.forEach(element => {
                  recipientData.push({
                    customerId: element.CustomerId,
                    customerName: element.CustomerName,
                    customerContactName: element.CustomerContactName,
                    customerEmail: element.CustomerContactEmail,
                    sourceName: element.DataSource
                  });
                });
                const sourceName = [...new Set(newdata.map(x => x.DataSource))];

                let sourceEle = [];
                sourceName.forEach(source => {
                  sourceEle.push({label: source, value: source})
                });
                this._QnSbnDataService.getMappedQnsbnData({ 
                  recipientTable: recipientData,
                  sourceName: sourceEle
                },"Recipient")
              }
            },
            (error: HttpErrorResponse) => {
              this.qnsbnService.httpErrorHandler(error, 'Could not fetch contact details.');
            }
          );
          
          const notificationData = versionData.NotificationId ? versionData : row;
          this.qnsbnService.setLocalNotificationID(notificationData.LocalId || row.LocalId);
          this._QnSbnDataService.getMappedQnsbnData(notificationData,"DraftNotification");
          this._QnSbnDataService.getMappedQnsbnData(
            {
              "NotificationId": versionData.NotificationId,
              "Type": notificationData.Type || row.Type,
              "Title": notificationData.Title || row.Title,
              "GlobalId": notificationData.GlobalId || row.GlobalId,
              "Country": notificationData.Country || row.Country,
              "GlobalNotificationId": notificationData.GlobalNotificationId || row.GlobalNotificationId,
              "CreationDate": notificationData.CreationDate || row.CreationDate,
              "LocalId": notificationData.LocalId || row.LocalId,
              "Status": notificationData.Status || row.Status,
              "UserId": notificationData.UserId || row.UserId,
              "UserRole": notificationData.UserRole || row.UserRole,
              "LocalNotificationLanguage": notificationData.LocalNotificationLanguage || row.LocalNotificationLanguage
            },"LocalNotificationId");
          
          if(notificationData.NotificationDocuments && notificationData.NotificationDocuments.length > 0) {
            this._QnSbnDataService.getMappedQnsbnData(notificationData.NotificationDocuments[0],"NotificationDoc");
          }
          if(notificationData.CustomerFeedbackItems) {
            const feedbackData = [];
            notificationData.CustomerFeedbackItems.forEach(element => {
              feedbackData.push({
            dragHandle: '',
            selectType: element.FeedbackItemType,
            selectText: element.FeedbackItemLabel,
            selectMandatory: element.FeedbackItemMandatory || 'Mandatory',
            iconSets: 'more-icon',
                dropDownOpt: element.FeedbackItemDropdown || [],
                radioOpt: element.FeedbackItemRadio || []
              });
            });
            this._QnSbnDataService.getMappedQnsbnData(feedbackData,"ConfigureFeedBack");
          }
          if(notificationData.MessageTitle || notificationData.MessageBody)
            this._QnSbnDataService.getMappedQnsbnData({
              "subjectName":notificationData.MessageTitle,
              "messageAttachmentRTEText":notificationData.MessageBody,
              "templateId": notificationData.TemplateId || ""
            },"MessageAttachment");
          if(notificationData.NotificationAttachments) {
            const fileList = [];
            let fileSize = 0;
            notificationData.NotificationAttachments.forEach(element => {
              const filetype = element.FileName.split('.').pop();
              fileSize = fileSize + element.FileSize;
              if(element.NotificationDoc) {
                this._QnSbnDataService.getMappedQnsbnData([{
                  name: element.FileName,
                  size: element.FileSize,
                  type: filetype,
                  fileIcon: this.appUtils.formatFilesIcons(filetype)
                }],"NotificationDocFileList");
              } else {
                fileList.push(<any>{
                  name: element.FileName,
                  size: element.FileSize,
                  type: filetype,
                  fileIcon: this.appUtils.formatFilesIcons(filetype)
                });
              }
            });
            this._QnSbnDataService.getMappedQnsbnData({
              "fileList": fileList,
              "totalAllFileSize": fileSize,
              "fileSizeobject": {}
            },"MessageAttachmentFileList");
          }
          if(notificationData.FeedbackDueDate)
            this._QnSbnDataService.getMappedQnsbnData({
              "feedbackDueDate":notificationData.FeedbackDueDate
            },"FeedbackDueDate");
          const notificationReminders = Array.isArray(notificationData.NotificationReminders) ? notificationData.NotificationReminders : [];
          if(notificationReminders.length > 0) {
            const reminderData = notificationReminders.map(element => ({
              reminderId: element.ReminderId,
              reminderDate: element.ReminderDueDate,
              reminderSubject: element.ReminderSubject,
              reminderMessage: element.ReminderMessage,
              reminderSendMode: element.ReminderSendAutomatically ? '0' : '1',
              reminderSendAutomatically: element.ReminderSendAutomatically,
              reminderSendStatus: element.ReminderSendStatus || 'Not Sent',
              reminderAddTemplate: element.ReminderAddTemplate || '',
              reminderActionIcons: true
            }));
            this._QnSbnDataService.getMappedQnsbnData({
              "remindersData": reminderData
            },"NotificationReminders");
          } else {
            this._QnSbnDataService.getMappedQnsbnData({
              "remindersData": []
            },"NotificationReminders");
          }
          const dueDateToggle = notificationData.DueDateEnabled ?? notificationData.dueDateEnabled;
          if(typeof dueDateToggle === 'boolean') {
            this._QnSbnDataService.setDDToggle(dueDateToggle);
          }
          const feedbackToggle = notificationData.FeedbackEnabled ?? notificationData.feedbackEnabled;
          if(typeof feedbackToggle === 'boolean') {
            this._QnSbnDataService.setFBToggle(feedbackToggle);
          }
          this.router.navigateByUrl('/create-notification', { state: { notificationData: notificationData } });
        },
        (error: HttpErrorResponse) => {
         
          this.qnsbnService.httpErrorHandler(error, 'Failed to create notification version.');
        }
      );
    } else {
     
       this.snackBarNotification.snackBarMessage('alarm', 'You do not have permission to create a new version');
    }
  }

}

